<div class="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center">
  <div
    class="tw-relative tw-max-h-[90vh] tw-w-full tw-max-w-md tw-overflow-y-auto tw-rounded-lg tw-bg-white tw-p-6 tw-shadow-lg"
  >
    <!-- Close Button -->
    <button
      aria-label="Close modal"
      class="tw-absolute tw-right-2 tw-top-2 tw-cursor-pointer tw-bg-transparent tw-text-xl tw-font-bold"
      (click)="activeModal.dismiss()"
      type="button"
    >
      &times;
    </button>

    <!-- Modal Content -->
    <div class="tw-text-black">
      <h2 class="tw-mb-6 tw-text-center tw-text-xl tw-font-bold">
        {{ 'support.title' | translate }}
      </h2>
    </div>

    <form (ngSubmit)="submit()" #contactForm="ngForm" novalidate>
      <div class="tw-mb-4">
        <label for="email" class="tw-mb-2 tw-block tw-text-sm tw-font-medium tw-text-black"
          >Email</label
        >
        <input
          id="email"
          name="email"
          type="email"
          [(ngModel)]="formData.email"
          placeholder="Email"
          required
          class="tw-w-full tw-rounded tw-border tw-p-2 tw-outline-none focus:tw-ring-2"
          #emailModel="ngModel"
        />
        <div class="tw-mt-1 tw-h-4 tw-text-sm tw-text-primary">
          @if (submitted && !formData.email) {
            <span>
              {{ 'support.emailMessage' | translate }}
            </span>
          }
          @if (submitted && emailModel.errors?.['email']) {
            <span>
              {{ 'support.emailMessageInvalid' | translate }}
            </span>
          }
        </div>
      </div>
      <div class="tw-mb-4">
        <label for="subject" class="tw-mb-2 tw-block tw-text-sm tw-font-medium tw-text-black"
          >Subject</label
        >
        <input
          id="subject"
          name="subject"
          type="text"
          [(ngModel)]="formData.subject"
          placeholder="Subject"
          required
          class="tw-w-full tw-rounded tw-border tw-p-2 tw-outline-none focus:tw-ring-2"
        />

        <div class="tw-mt-1 tw-h-4 tw-text-sm tw-text-primary">
          @if (submitted && !formData.subject) {
            <span>
              {{ 'support.subjectMessage' | translate }}
            </span>
          }
        </div>
      </div>
      <div class="tw-mb-4">
        <label for="message" class="tw-mb-2 tw-block tw-text-sm tw-font-medium tw-text-black"
          >Message</label
        >
        <textarea
          id="message"
          name="message"
          [(ngModel)]="formData.message"
          placeholder="Message"
          rows="4"
          required
          class="tw-w-full tw-rounded tw-border tw-p-2 tw-outline-none focus:tw-ring-2"
        ></textarea>
        <div class="tw-mt-1 tw-h-4 tw-text-sm tw-text-primary">
          @if (submitted && !formData.message) {
            <span>
              {{ 'support.messageMessage' | translate }}
            </span>
          }
        </div>
      </div>

      <!-- attachment -->
      <!-- <div class="tw-mb-4">
          <label class="tw-block tw-text-sm tw-font-medium tw-mb-2 tw-text-black">Attachments (optional)</label>
          <label
            for="attachments"
            class="tw-border-2 tw-border-dashed tw-rounded tw-p-4 tw-text-gray-500 tw-flex tw-items-center tw-gap-2 tw-cursor-pointer hover:tw-bg-gray-100"
            >
            <span class="tw-text-red-500 tw-font-medium"> Add</span>
            <span>up to five (5) files</span>
          </label>
          <input
            id="attachments"
            name="attachments"
            type="file"
            multiple
            class="tw-hidden"
            (change)="onFilesSelected($event)"
            />
          </div> -->

      <button
        type="submit"
        class="tw-w-full tw-rounded tw-bg-black tw-py-2 tw-font-medium tw-text-white hover:tw-bg-gray-800 disabled:tw-bg-gray-400"
      >
        Submit
      </button>
    </form>
  </div>
</div>
